<template>
  <div>
    <div v-if="this.company" class="menu-items">
      <a
        href="/commercial/manage_campaigns"
        class="term cursor-pointer"
        :class="this.menuSelected.campaigns && 'search-active'"
        >{{ $t("manageCampaignsLabel") }}</a
      >
      <a
        href="/commercial/manage_partners"
        class="policy cursor-pointer"
        :class="this.menuSelected.partners && 'dashboard-active'"
        >{{ $t("managePartnersLabel") }}</a
      >
      <a
        href="/account"
        class="amanage cursor-pointer"
        :class="this.menuSelected.account && 'amanage-active'"
        >{{ $t("settingsName") }}</a
      >

      <a href="#" class="logout" @click="logout()">{{ $t("logoutName") }}</a>
    </div>
    <div class="socials">
      <a href="https://www.facebook.com/UpRomania" class="facebook"></a>
      <a
        href="https://www.linkedin.com/company/up-romania"
        class="linkedin"
      ></a>
      <a
        href="https://www.youtube.com/c/UpRomaniaBucuresti"
        class="youtube"
      ></a>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";

export default {
  name: "MenuItemsCommercial",
  props: {
    company: Object,
    menuSelected: {
      campaigns: false,
      partners : false,
      account: false,
    },
    user: Object
  },
  methods: {
    logout() {
      Cookies.remove("user_data");;
      Cookies.remove("userLink");
      Cookies.remove("user_role");
      Cookies.remove("token");
      this.$router.push({
        name: "login",
        params: { loginUserSelected: false }
      });
    },
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
  },
  mounted() {
    if (this.menuSelected.companySearch) {
      this.company.companyId = "0";
    }
  }
};
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
